import React from 'react'
import { useConfig } from '@context/ConfigurationContext'
import { AppMode } from '@customTypes/Generic'
import { useTranslation } from 'react-i18next'
import { useStyles } from './AppointmentCalendarHeader.styles'
import PeriodDays from './PeriodDays'
import { useCalendarVariant } from '@screens/Appointment/helpers/useCalendarVariant'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import clsx from 'clsx'
import { isCurrentPeriodUndefined } from '@context/AppointmentCalendarContext/helpers/isCurrentPeriodEmpty'

export const AppointmentCalendarHeader = () => {
  const { mode, clinicId } = useConfig()
  const { t } = useTranslation()
  const classes = useStyles()
  const isGapFiller = mode === AppMode.GAP_FILLER
  const variant = useCalendarVariant()
  const { currentPeriod, isMoreClinicsOpen } = useAppointmentCalendar()
  const currentWeek = currentPeriod[clinicId]

  if (isCurrentPeriodUndefined(currentPeriod)) return null

  return (
    <div className={clsx(classes.headerWrapper, { [classes.multipleClinicsWrapper]: isMoreClinicsOpen })}>
      <div className={classes.headerContainer}>
        {isGapFiller && !isCurrentPeriodUndefined(currentPeriod) && (
          <div className={classes.headerTitle}>{t('appointment_page_calendar_header_gap_filler')}</div>
        )}
        <PeriodDays currentWeek={currentWeek} variant={variant} />
      </div>
    </div>
  )
}
